import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'

const i18n = {
  submit: () => t('submit', { ns: 'csc-rma-submit-button', default: 'Submit request' }),
}

export const RMA_SUBMIT_REQUESTED = 'csc-rma-submit-requested'

@customElement('csc-rma-submit-button')
export class CSCRmaSubmitButton extends LitElement {
  protected override createRenderRoot = () => this

  private onClick() {
    this.dispatchEvent(new CustomEvent(RMA_SUBMIT_REQUESTED, { bubbles: true, composed: true }))
  }

  override render() {
    return html`
      <cse-button variant="primary" @click="${() => this.onClick()}"> ${i18n.submit()} </cse-button>
    `
  }
}
